import { render, staticRenderFns } from "./StatementTermination.vue?vue&type=template&id=3b8b8360&"
import script from "./StatementTermination.vue?vue&type=script&lang=js&"
export * from "./StatementTermination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports